var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M7.5 5.67h1.65v7.551c0 .099.08.179.178.179h1.34a.18.18 0 0 0 .178-.179v-7.55H12.5c.15 0 .232-.173.14-.289l-2.5-3.165a.18.18 0 0 0-.28 0L7.36 5.38a.18.18 0 0 0 .14.29m10.67 6.882h-1.34a.18.18 0 0 0-.178.178v3.438H3.348V12.73a.18.18 0 0 0-.179-.178H1.83a.18.18 0 0 0-.178.178v4.42c0 .395.319.714.714.714h15.268c.395 0 .714-.319.714-.714v-4.42a.18.18 0 0 0-.178-.178"
  })));
};
export default SvgUpload;